<template>
  <div class="hello">

      <div class='container'>
            <transition name="fade">
                <div v-if="addingFile" class="loading">
                    <p>Uploading Image...</p>
                </div>
            </transition>
        </div>

        <!-- Error modal if not image type -->
        <b-modal id="modal-error" ok-only title="Error" ok-title="OK">
            {{errMsg}}
        </b-modal>

    <b-container>
        <b-row>
            <b-col>
                <h4>Start New Thread</h4>
            </b-col>
        </b-row>
    
        <!-- Error -->
        <div style="color:red" v-if="newPostError">Must enter at least five characters for subject and post</div>

        <!-- Subject -->
        <b-form-group id="fieldset-4" label="Subject" label-for="input-5">
            <b-form-input id="input-5" v-model="newPost.subject"></b-form-input>
        </b-form-group>

        <!-- Post Details -->
        <b-form-group label="Your Post" label-size="m" label-align-sm="top" label-for='description'>
            <b-form-textarea  size="sm" id='description' v-model="newPost.post" rows="3" max-rows="6"></b-form-textarea>
        </b-form-group>

        <!-- Image 1 -->
        <b-card style="width: 300px; margin:10px; ">
            <input id="image1"  @change="onLogoFileChanged($event, 'image1')"  type="file" hidden>
            <div style="height:110px; text-align: center;  margin-bottom:10px">
                <img v-if="newPost.imagethumburl1" @click="chooseFiles($event, 'image1')" style="cursor: pointer;" height="100px" :src="newPost.imagethumburl1"/>
                <b-button size="lg" v-else @click="chooseFiles($event, 'image1')"><font-awesome-icon icon="camera" /> Optional Image</b-button>
            </div>
        </b-card>

        <!-- Buttons -->
        <b-row>
            <b-col>
                <b-button variant="primary" @click="startThread()">Start Thread</b-button>
                <b-button style="margin-left:10px" variant="outline-danger" @click="cancelThread()">Cancel</b-button>
            </b-col>
        </b-row>
        
    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')
import axios from 'axios'
import {timeConverterObject} from '../Myfunctions'


export default {    
    props: ['userHandle'], //Needed for new handles

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
        
    },

    data() {
        return {
            errMsg:'',
            handleExists:false,
            newPost:{
                subject:'',
                post:'',
                createdOn:'',
                createdByHandle:'',
                createdByCompany:'',
                createdByUid:'',
                imageurl1:'',
                imagethumburl1:''
            },
            newPostError:false,

            addingFile:false,
            cloudinary: {
                logoFullPreset:'forumfullimage',
                logoThumbPreset:'forumthumbnailimage',
                apiKey: '629997215451183',
                cloudName: 'lo4xxr5lr',
                uploadURL:'https://api.cloudinary.com/v1_1/lo4xxr5lr/upload'
            },

        }
    },

    methods:{
        //Choose image files
        chooseFiles(event, imagenumber) {
            console.log("Choosing image")
            document.getElementById(imagenumber).click()
        },

        //Image file changed
        onLogoFileChanged (event, imagenumber) {
            console.log("File changed: " + imagenumber)
            this.selectedFile = event.target.files[0]
            const name = event.target.files[0].name;
            const lastDot = name.lastIndexOf('.');

            this.fileName = name.substring(0, lastDot);
            this.fileExtension = name.substring(lastDot + 1);

            console.log(this.fileName, this.fileExtension)

            //Check file extention
            this.fileExtension=this.fileExtension.toLowerCase()
            if(this.fileExtension!='jpg'&&this.fileExtension!='jpeg'&&this.fileExtension!='png'){
                this.errMsg="Image must be a JPEG or PNG"
                this.$bvModal.show("modal-error")
                return
            }
            this.uploadLogotoCloudinary(imagenumber)
        },

        //Upload file
        uploadLogotoCloudinary(imagenumber){
            this.addingFile = true
            let data = new FormData();
            data.append('file', this.selectedFile); 

            //Upload full image
            data.append('upload_preset', this.cloudinary.logoFullPreset);
            axios
                .post(this.cloudinary.uploadURL, data)
                .then((result) => {
                    if(result.data.secure_url){
                        console.log("URL main: " + result.data.secure_url)
                        if(imagenumber=='image1') this.newPost.imageurl1 = result.data.secure_url
                        else if(imagenumber=='image2') this.newPost.imageurl2 = result.data.secure_url
                        else if(imagenumber=='image3') this.newPost.imageurl3 = result.data.secure_url
                        else if(imagenumber=='image4') this.newPost.imageurl4 = result.data.secure_url
                        else if(imagenumber=='image5') this.newPost.imageurl5 = result.data.secure_url
                        else if(imagenumber=='image6') this.newPost.imageurl6 = result.data.secure_url
                    }
                    this.addingFile = false

                })
                .catch((err) => {
                    console.log('Ax Error:' + err);
                    
                    this.addingFile = false
                }) 

            //Upload thumbnail
            let thumbdata = new FormData();
            thumbdata.append('file', this.selectedFile); 
            thumbdata.append('upload_preset', this.cloudinary.logoThumbPreset);

            axios
                .post(this.cloudinary.uploadURL, thumbdata)
                .then((result) => {
                    if(result.data.secure_url){
                        console.log("URL thumbnail: " + result.data.secure_url)
                        //Add thumbnail url
                        if(imagenumber=='image1') this.newPost.imagethumburl1 = result.data.secure_url
                        else if(imagenumber=='image2') this.newPost.imagethumburl2 = result.data.secure_url
                        else if(imagenumber=='image3') this.newPost.imagethumburl3 = result.data.secure_url
                        else if(imagenumber=='image4') this.newPost.imagethumburl4 = result.data.secure_url
                        else if(imagenumber=='image5') this.newPost.imagethumburl5 = result.data.secure_url
                        else if(imagenumber=='image6') this.newPost.imagethumburl6 = result.data.secure_url
                    }
                    this.addingFile = false
                })
                .catch((err) => {
                    console.log('Ax Thumb Error:' + err);
                    this.addingFile = false
                })

        },

        //Start new thread
        startThread(){

            if(this.newPost.subject.length<4||this.newPost.post.length<4){
                this.newPostError=true
                return
            }
            else{
                var min=11111111111111111; 
                var max=99999999999999999;  
                var randomId = Math.floor(Math.random() * (+max - +min)) + +min; 
                var randomIdString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)

                console.log("Starting new thread")
                //Add to forum titles
                var theDate = new Date()
                //Add current user to voted uid
                var voteduid = [this.currentUser.uid]
                var users = [this.currentUser.uid]
                const titleData = {createdOn: theDate, subject:this.newPost.subject, originalpost:this.newPost.post, lastpost:this.newPost.post
                    , createdbyhandle:this.userHandle, createdbyuid:this.currentUser.uid, createdbyemail:this.currentUser.email
                    , createdbycompany:this.userProfile.company, totalposts:1, lastposthandle:this.userProfile.userhandle, lastpostdate:theDate,
                    lastpostuid:this.currentUser.uid, lastpostcompany:this.userProfile.company, imageurl1:this.newPost.imageurl1, imagethumburl1:this.newPost.imagethumburl1
                    , votes:0, voteduid:voteduid, views:0, users:users }
                    
                var newPostTitleRef = fb.forumTitlesCollection.doc(randomIdString)
                newPostTitleRef.set(titleData)

                //Add to forums collection
                var randomId2 = Math.floor(Math.random() * (+max - +min)) + +min; 
                var randomIdString2 = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
                const newPost =  {createdOn: theDate, post:this.newPost.post
                    , createdbyhandle:this.userProfile.userhandle, createdbyuid:this.currentUser.uid, createdbyemail:this.currentUser.email
                    , createdbycompany:this.userProfile.company, imageurl1:this.newPost.imageurl1, imagethumburl1:this.newPost.imagethumburl1
                    ,isreply:0, postid:randomIdString2, votes:0}

                const postsArray = [newPost]
                const newPostInfo = {postinfo: titleData, postsarray:postsArray}
                var newPostDetailsRef = fb.forumsCollection.doc(randomIdString)
                newPostDetailsRef.set(newPostInfo)

                //Hide the modal
                console.log("Hiding modal")
                this.$emit('closeNewThreadModal')
                
            }
        },

        //Cancel thread
        cancelThread(){
            this.$emit('closeNewThreadModal')
        },


    },

    mounted(){
    },
}
</script>

